/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import useDebounce from 'modules/common/components/UseDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import CitizenContent from './CitizenContent';
import CitizenModal from '../modals/CitizenModal';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'CDL',
};

function CitizenContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
  startAssessment,
  tagAsPrintedTransaction,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
      transaction_type: 'INDIVIDUAL',
    });
    getTransactionList({
      ...filter,
      transaction_status: e.value,
      transaction_type: 'INDIVIDUAL',
    });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm) {
      getTransactionList({
        q: formData.keyword,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as received this application?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          approveTransaction(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsPrinted = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as printed this application?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          tagAsPrintedTransaction(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          approveTransaction(
            _.get(data, 'id'),
            {
              remarks,
              status: 'PENDING LAB TEST',
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const getExtName = (item) =>
    _.get(item, 'included.module.attributes.extension_name');

  const handleButtonClicked = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CitizenModal
          // taxpayers={taxpayer}
          // taxpayerId={selectedTransaction}
          type="NEW"
        />
      ),
      title: 'Add New Citizen',
      modalSize: 'modal-xl',
    });
  };

  return (
    <>
      {Acl(permissions, ['ADD CITIZEN']) && (
        <div className="row d-flex justify-content-end mr-3">
          <button
            onClick={handleButtonClicked}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  mt-2"
            type="button"
          >
            Add New Citizen
          </button>
        </div>
      )}
      <div className="card-content-listing">
        <Route
          path={`${match.path}/:id?`}
          render={({ match: { params } }) => (
            <GenericListPair
              moduleName="Citizen Profiles"
              getData={getTransactionList}
              setParams={param}
              setKeyword={handleOnChange}
              setStatusFilter={handleOnChangeSelect(
                _.get(formData, 'transaction_status')
              )}
              status={_.get(filter, 'transaction_status') || ''}
              keyword={_.get(formData, 'keyword') || ''}
              keywordPlaceholder="Search Transaction..."
              pathName={`${match.path}/:id?`}
              listName="Transaction"
              label="Application List"
              renderItem={(item) => (
                <div className="px-3 py-3">
                  <div className="transaction-list-company">
                    {`${_.get(item, 'attributes.first_name')} ${_.get(item, 'attributes.middle_name') || ''
                      } 
                  ${_.get(item, 'attributes.last_name')}  ${getExtName(item) || ''
                      }`}
                  </div>
                  <h4 className="mt-1 mb-0 transaction-list-name">
                    {' '}
                    {_.get(item, 'attributes.birth_date')}{' '}
                  </h4>
                </div>
              )}
              isLoading={isLoading}
              selected={params.id}
              data={transactionList}
              dataPager={transactionListPager}
              handleSelectRow={(data) => {
                history.push(`${match.url}/${_.get(data, 'id')}`);
              }}
              renderContent={() => (
                <React.Fragment>
                  <Switch>
                    <Route
                      path={`${match.path}/:id?`}
                      render={() => (
                        <CitizenContent
                          UpdateData={UpdateData}
                          onApprove={handleApprove}
                          onTagAsPrinted={handleTagAsPrinted}
                          onReject={handleReject}
                        />
                      )}
                    />
                  </Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() =>
                      !params.business_Id && transactionList.length > 0 ? (
                        <Redirect
                          to={`${match.url}/${_.get(transactionList, '0.id')}`}
                        />
                      ) : null
                    }
                  />
                </React.Fragment>
              )}
            />
          )}
        />
      </div>
    </>
  );
}

CitizenContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  tagAsPrintedTransaction: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CitizenContainer);
